let React               = require("react");

let ContentServerClient = require("../../../ContentServerClient.js");
let WrappedModalHub     = require("./WrappedModalHub.jsx");
let Utilities =           require("../../../util/Utilities.js");

class CreateModalHub extends React.Component {

    constructor(){
        super();

        this.createHub = this.createHub.bind(this);
        this.onHubSelected = this.onHubSelected.bind(this);
        this.checkSpecialCharacters = this.checkSpecialCharacters.bind(this);
    }

    shouldComponentUpdate(nextProps){
        return  nextProps.show !== this.props.show
    }

    componentDidUpdate(){
        this.name.value = "";
        this.name.classList.remove("invalid")
    }

    onHubSelected(id, name){
        this.props.history.push(`/hubs/${id}-${encodeURIComponent(name)}/libraries`);
    }

    createHub(){
        let {onClose, setLoading, handleError} = this.props;

        if(this.name.value === "" || Utilities.hasSpecialCharacters(this.name.value)){return}

        setLoading(true, `Creating hub ${this.name.value}...`);

        ContentServerClient.createHub(handleError, this.name.value)
            .then(hub => {
                setLoading(false);
                onClose("create");
                this.onHubSelected(hub.id, hub.name);
            })
            .catch(error => setLoading(false));
    }

    componentDidUpdate(){
        //this obj is null after the user get more than 16 hub
        if(this.name){ this.name.value = ""}
    }

    checkSpecialCharacters(){
         if(Utilities.hasSpecialCharacters(this.name.value)){
             this.name.classList.add("invalid")
         }else{
             this.name.classList.remove("invalid")
         }
    }

    render() {

        const {onClose, show, hubCounts:{ allowedNumberOfHubs, currentNumberOfHubs}} = this.props;
        const doneLoading = allowedNumberOfHubs != -1;
        const createMore = currentNumberOfHubs < allowedNumberOfHubs;
        const allowedHubs = allowedNumberOfHubs - currentNumberOfHubs;

        return  <WrappedModalHub show={show} style="fifty" title={`New ${fullHubAlias}`}
                    btnBlue={{show: true, text: "Create", disable: createMore? "false": "true",
                                onClick: createMore? this.createHub: null}}
                    onClose={() => onClose("create")}
                >
                { doneLoading &&
                    <div className="createModalHub">
                        {createMore &&  <div className="createModalHub__contName">
                                    <p className="bold">{hubAlias} Name:</p>

                                    <input type="text" onChange={this.checkSpecialCharacters} ref={div => this.name = div}/>
                                    <p className="warning">Special characters are not allowed.</p>

                            </div>}
                        <div className="clear"></div>
                        {createMore && <p>You can create up to <span className="bold">{allowedHubs}</span> more {fullHubAlias}{(allowedHubs != 1)?"s":""} on your account.</p>}
                        {!createMore && <p>You cannot create more than <span className="bold">{allowedNumberOfHubs}</span> hubs.</p>}
                    </div>
                }
                { !doneLoading &&
                    <p>Loading...</p>
                }
                </WrappedModalHub>
    }
}

module.exports = CreateModalHub;
